import { httpService } from '@/services/httpService'
import type { ApiResponse } from '@/types/api'

type Config = Parameters<typeof httpService.get>[1]

export function get<T>(url: string, config?: Config): Promise<ApiResponse<T>> {
  return httpService.get<ApiResponse<T>>(url, config).then((response) => response.data)
}

export function post<T>(url: string, data?: unknown, config?: Config): Promise<ApiResponse<T>> {
  return httpService.post<ApiResponse<T>>(url, data, config).then((response) => response.data)
}

export function put<T>(url: string, data?: unknown, config?: Config): Promise<ApiResponse<T>> {
  return httpService.put<ApiResponse<T>>(url, data, config).then((response) => response.data)
}

export function patch<T>(url: string, data?: unknown, config?: Config): Promise<ApiResponse<T>> {
  return httpService.patch<ApiResponse<T>>(url, data, config).then((response) => response.data)
}

export function del<T>(url: string, config?: Config): Promise<ApiResponse<T>> {
  return httpService.delete<ApiResponse<T>>(url, config).then((response) => response.data)
}
